import React, { useState, useMemo, useEffect } from "react";
import { Tabs } from "antd";
import Layout from "../../components/Layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import BudgetValidation from "./components/BudgetValidation/BudgetValidation";
import TrainingApproval from "./components/TrainingApproval/TrainingApproval";
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle";
import Mouse from "../../components/Mouse/Mouse";
import ScrollTop from "../../components/ScrollTop/ScrollTop";

function ProjectManagerSpace() {

  const items = useMemo(
    () => [
      {
        key: "budget-validation",
        label: "Budget Validation",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <BudgetValidation />
          </React.Suspense>
        ),
      },
      {
        key: "training-approval",
        label: "Training Request",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <TrainingApproval />
          </React.Suspense>
        ),
      },
    ],
    []
  );

  const getTab = (tab) => {
    if (tab === "budget-validation" || tab === "training-approval") {
      return tab;
    }
    return "budget-validation";
  };

  const refactorKey = (key) => {
    return key.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }

  const navigate = useNavigate();
  const { tab } = useParams();
  const [name, setName] = useState((tab) => getTab(tab));

  const onChangeHeaderName = (key) => {
    navigate(`../projectmanagerspace/${key}`);
  };

  useEffect(() => {
    setName(refactorKey(getTab(tab)));
  }, [tab]);

  return (
    <>
      <FlatTitle pageName={refactorKey(name)} />
      <div className="section-container">
        <div id="wrapper">
      <Tabs
        tabBarGutter={85}
        activeKey={getTab(tab)}
        items={items}
        onChange={onChangeHeaderName}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
          <Mouse />
          <ScrollTop />
        </div>
      </div>
    </>
  );
}

export default ProjectManagerSpace;
